export type PrizmSplitterOrientation = 'vertical' | 'horizontal';
